module.exports = "https://coursera_assets.s3.amazonaws.com/images/07d178f920943f5523b1d502d8798d75.jpg";